// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"242":"f3c6f3d0","313":"f3c6f3d0","510":"f3c6f3d0","652":"f3c6f3d0","873":"f3c6f3d0"}[chunkId] + ".chunk.css";
};